import { StyledGallaryCarouselModal, StyledGlobalHeader } from './GallaryCarouselModal.styles';
import { Modal } from '@marriott/mi-ui-library';
import { AwpHeroImageCarousel } from '../../../../molecules/AwpHeroImageCarousel';
import { useGetBreakpoint } from '../../../../modules/utils';
import { useEffect, useState } from 'react';
import clsx from 'clsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const GallaryCarouselModal = (props: any) => {
  const { GallaryTabData, imageIndex, dialogOpenState, setDialogOpenState } = props;
  let viewPort = useGetBreakpoint();
  const [isMobileViewPort, setIsMobileViewPort] = useState(viewPort === 'mobile');

  const galleryImages = GallaryTabData.map((imageUrl: string) => ({
    defaultImageUrl: imageUrl + '?downsize=1920:*',
  }));

  useEffect(() => {
    function handleResize() {
      // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps
      viewPort = useGetBreakpoint();
      setIsMobileViewPort(viewPort === 'mobile');
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dialogOpenState ? (
    <>
      <StyledGlobalHeader />
      <StyledGallaryCarouselModal>
        <Modal
          className={`custom-scrollbar  gallary-carousel-modal ${dialogOpenState ? '' : 'close-popup-header'}`}
          show={true}
          handleBlur={true}
          popupOpenState={dialogOpenState}
          setPopupOpenState={setDialogOpenState}
          allFilterPopUp={true}
        >
          <Modal.Body className="modal-gallary-body">
            <div>
              <div className="d-flex justify-content-end">
                <button
                  data-testid="close-button"
                  className={`popup-close-button icon-clear align-items-center d-flex justify-content-end 
               ${clsx(isMobileViewPort ? 'mt-3 mr-3' : 'mr-4 mt-4')}`}
                  onClick={() => setDialogOpenState(false)}
                ></button>
              </div>
              {galleryImages?.length > 1 ? (
                <AwpHeroImageCarousel
                  images={galleryImages}
                  imgCustomClass="gallary-overlay--img"
                  index={imageIndex}
                  hideCarouselPips={true}
                />
              ) : (
                <img
                  title=""
                  src={galleryImages[0]?.defaultImageUrl}
                  loading="eager"
                  alt="slide 1"
                  className="gallary-overlay--img"
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </StyledGallaryCarouselModal>
    </>
  ) : null;
};
